import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Link, Typography } from "@material-ui/core";
import { HIDDENFAULTS_TOKEN, HIDDENFAULTS_REFRESH } from "../../application/constants";
import { setTimeOutLogoutMessage, setAppInit, setIsAuthenticated } from "../../application/actions";
import { useAppState } from "../../application/AppState";
import useTranslation from "../../application/translation";


const useStyles = makeStyles({
    root: {
        display: "block",
        marginBottom: "1rem",
    },
    alert: {
        marginTop: ".5rem",
        marginBottom: ".5rem"
    },
    link: {
        marginLeft: ".2rem",
        marginRight: ".2rem",
    },
});

const tryVerifyPartner = async (data) => {
    const response = await fetch("verify", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
    });
    if (response.ok) return response;
    if (response.status == 401) {
        return Promise.reject("Unauthorized");
    }
    const json = await response.json();
    return Promise.reject(json);
};

const GetAssentlyToken = async () => {
    const response = await fetch("verify", {
        method: "GET",
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
    });
    if (response.ok) return response;
    if (response.status == 401) {
        return Promise.reject("Unauthorized");
    }
    const json = await response.json();
    return Promise.reject(json);
};


export const LoginAssently = () => {
    const [{ language }, dispatch] = useAppState();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [timeOut, setTimeOut] = useState(false);
    const { handleSubmit } = useForm({
        mode: "onChange",
    });
    const styles = useStyles();
    const translation = useTranslation();

    useEffect(() => {
        setTimeOut(JSON.parse(window.localStorage.getItem('timeOut')));
        localStorage.removeItem("timeOut");

        const path = window.location.pathname.replace(/\//g, '');
        if (path == 'dk' || path == 'no') {
            const queryParams = new URLSearchParams(window.location.search);
            const status = queryParams.get("status");
            if (status === 'authenticated') {

                
                const token = queryParams.get("identityToken");

                async function doLogin(token) {

                    try {
                    const response = await tryVerifyPartner({
                        partnerIdentity: token,
                        fromExternalPage: true
                    });
                    const auth = await response.json();
                    //redirect("EnterCard – PPI/LPI", `${auth.url}?t=${auth.token}&r=${auth.refreshToken}`);
                    sessionStorage.setItem(HIDDENFAULTS_TOKEN, auth.token);
                    sessionStorage.setItem(HIDDENFAULTS_REFRESH, auth.refreshToken);
                    dispatch(setAppInit(true));
                    dispatch(setTimeOutLogoutMessage(false));
                    dispatch(setIsAuthenticated(true))

                    } catch (error) {                        
                        setError(true);
                    } finally {
                        setLoading(false);                        
                    }
                }
                  doLogin(token);               
            }
        }
    }, []);

    const getAllowedEid = () => {
        if (language == 'no') {
            return ['no-bankid-oidc'];
        } else if (language == 'dk') {
            return ['dk-mitid'];
        } else {
            return ['se']
        }
    }

    const getDefaultProvider = () => {
        if (language == 'no') {
            return 'no-bankid-oidc';
        } else if (language == 'dk') {
            return 'dk-mitid';
        } else {
            return 'se-bankid';
        }
    }

    const InitAssently = (token) => {
        window.coreid_client.init({
            config: {
                allowedEids: getAllowedEid(),   // enable your eID providers
                mode: 'auth',         // sets the mode to authentication
                language: language,       // set the client to use swedish language
                provider: getDefaultProvider(),// default provider to show on start
                providerSettings: {
                    'no-bankid-oidc': {
                        ux_mode: 'redirect'
                    }
                }
            },
            token: token,
            callback: async function (data) {
                if (data.success == true) {
                    window.coreid_client.close();
                    try {
                        setLoading(true);
                        const response = await tryVerifyPartner({
                            partnerIdentity: data.token,
                            fromExternalPage: false
                        });
                        const auth = await response.json();
                        //redirect("EnterCard – PPI/LPI", `${auth.url}?t=${auth.token}&r=${auth.refreshToken}`);
                        sessionStorage.setItem(HIDDENFAULTS_TOKEN, auth.token);
                        sessionStorage.setItem(HIDDENFAULTS_REFRESH, auth.refreshToken);
                        dispatch(setAppInit(true));
                        dispatch(setTimeOutLogoutMessage(false));
                        dispatch(setIsAuthenticated(true))

                    } catch (error) {
                        setError(true);
                    } finally {
                        setLoading(false);
                    }
                }
            }
        });
        // start the client!
        window.coreid_client.start();
    };


    const onSubmit2 = async ({ partnerIdentity }) => {
        const response = await GetAssentlyToken();
        const val = await response.json()
        InitAssently(val.token);

    };

    // 212000-0142
    return (
        <>
            <div style={{ minHeight: '200px', width: '90%', display: "flex", justifyContent: "center", alignItems: "center", paddingLeft: "5%" }}>
                <form onSubmit={handleSubmit(onSubmit2)} autoComplete="off">
                    {timeOut &&
                        <Alert severity="error" className={styles.alert}>
                            <AlertTitle>Info</AlertTitle>
                            <Typography variant="body2" component="p">
                                Du har tyvärr blivit utloggad då det tagit för lång tid. Det innebär att din anmälan inte har registrerats. Vänligen logga in och försök igen.
                            </Typography>
                        </Alert>
                    }
                    <Typography variant="h5" align='center'>
                        {translation.login_header}
                    </Typography><br />
                    <Typography variant="subtitle2" align='center'>
                        {translation.login_text}
                    </Typography>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "10px", paddingBottom: "10px" }}>
                        <Button variant="contained" color="primary" size="large" type="submit">{translation.login_button}</Button>
                    </div>

                    {(error && language == "sv") && (
                        <Alert severity="error" className={styles.alert}>
                            <AlertTitle>Info</AlertTitle>
                            <Typography variant="caption" component="p">
                                Vi kan tyvärr inte hitta dig i vårt Försäkringsregister.
                            </Typography>
                            <Typography variant="caption" component="p">
                                Vänligen kontakta Entercard på <br /><Link className={styles.link} href="tel:+46-8-737 14 00">
                                    08-737 14 00
                                </Link> för att kontrollera dina försäkringar.
                            </Typography>
                        </Alert>
                    )}
                    {(error && language == "no") && (
                        <Alert severity="error" className={styles.alert}>
                            <AlertTitle>Info</AlertTitle>
                            <Typography variant="caption" component="p">
                                Vi finner deg dessverre ikke i vårt forsikringsregister.
                            </Typography>
                            <Typography variant="caption" component="p">
                                Vennligst kontakt Entercard for å kontrollere forsikringen. <br /> Du finner kontaktinformasjonen <Link className={styles.link} href="https://www.entercard.no/kontakt/kundeservice/">her</Link>.
                            </Typography>
                        </Alert>
                    )}
                </form>
            </div>
        </>
    );
};

export default LoginAssently;
